import {assertAndContinue} from '../Asserts';
import {SchemaTag} from '../folder-items/FileConstants';
import {
  BatchLinkSchemaField,
  BioentityLinkSchemaField,
  FIELD_TYPES,
  SchemaField,
} from '../schemas/fields/SchemaFieldConstants';
import {AssaySchema} from './assay-schemas/AssaySchemaConstants';
import {AssayResult} from './assays/AssayRecordConstants';
import {getTagForField} from './assays/getTagForField';

export const PRIMARY_LINK_TYPES = [FIELD_TYPES.BATCH_LINK.type, FIELD_TYPES.BIOENTITY_LINK.type];

export function getPrimaryLinkField(
  assaySchema: AssaySchema
): BatchLinkSchemaField | BioentityLinkSchemaField | undefined {
  return assaySchema.fields.find((field) => PRIMARY_LINK_TYPES.includes(field.fieldType)) as
    | BatchLinkSchemaField
    | BioentityLinkSchemaField
    | undefined;
}

export function getPrimaryLinkTagForResult(
  primaryLinkField: SchemaField | undefined,
  result: AssayResult
): SchemaTag | null {
  if (!primaryLinkField) {
    return null;
  }
  const tagForPrimaryLinkField = getTagForField(result, primaryLinkField.id);
  assertAndContinue(
    Boolean(tagForPrimaryLinkField),
    `Expected result with id ${result.id} to have tag for primary link field ${primaryLinkField.apiId}`
  );
  return tagForPrimaryLinkField || null;
}
